import { Autocomplete, TextField } from "@mui/material";
import { useAuth, usePartners } from "hooks";
import React, { useMemo } from "react";

interface SelectPartnerForOverviewProps {
    setPartnerId: (id?: number) => void;
    partnerId?: number;
}
export const SelectPartnerForOverview = ({ partnerId, setPartnerId }: SelectPartnerForOverviewProps) => {
    const { partners } = usePartners();
    const { currentUserId } = useAuth();
    const selectedPartner = useMemo(() => {
        const selectedPartnerId = partnerId ?? currentUserId;
        return partners?.filter(partner => partner.id === selectedPartnerId)
            .map(partner => {
                return { label: `${partner.email}`, value: partner.id }
            })[0];
    }, [partners, partnerId]);
    return (
        <>
            <Autocomplete
                sx={{ display: 'inline-flex', width: '80%' }}
                renderInput={(params) => {
                    return <TextField {...params} sx={{ m: 2, display: 'inline-flex' }} />;
                }}
                disableClearable
                options={partners?.map(partner => ({ label: `${partner.email}`, value: partner.id })) || []}
                value={selectedPartner}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onChange={(_, item) => setPartnerId(item?.value)}
            />
        </>
    );
}